var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleCheckThick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  x: 1,
  y: 1,
  fill: "#333",
  rx: 15
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M22.663 10.918a1 1 0 0 1 .085 1.412l-7.68 8.666a1 1 0 0 1-1.418.08l-4.32-3.9a1 1 0 0 1 1.34-1.485l3.571 3.224 7.01-7.912a1 1 0 0 1 1.412-.085",
  clipRule: "evenodd"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  x: 1,
  y: 1,
  stroke: "#333",
  strokeWidth: 2,
  rx: 15
})));
export { SvgCircleCheckThick as ReactComponent };